import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CategoryType, PageResponse } from '@core/shared/domain';
import { CategoryBase } from '@mpcm/shared';
import { PlatformSupplierBasic } from '@mpsm/shared/domain';

import type {
  ArticleRange,
  ArticleRangeInfo,
  ArticleRangeSearchRequest,
  CategoriesFilterQueryModel,
  CreateArticleRange,
  OrganizationBasic,
  PlatformSupplierFilterQueryModel,
  UpdateArticleRange,
} from '../models';

@Injectable()
export class ArticleRangeService {
  private readonly baseUrl = '/api/contentmanagement/articles/ranges';

  constructor(private readonly http: HttpClient) {}

  public getArticleRangeInfos(request?: ArticleRangeSearchRequest): Observable<PageResponse<ArticleRangeInfo>> {
    return this.http.get<PageResponse<ArticleRangeInfo>>(this.baseUrl, {
      params: {
        ...request,
      },
    });
  }

  public getArticleRange(id: string): Observable<ArticleRange> {
    return this.http.get<ArticleRange>(`${this.baseUrl}/${id}`);
  }

  public createArticleRange(dto: CreateArticleRange): Observable<ArticleRange> {
    return this.http.post<ArticleRange>(this.baseUrl, dto);
  }

  public updateArticleRange(id: string, dto: UpdateArticleRange): Observable<ArticleRange> {
    return this.http.put<ArticleRange>(`${this.baseUrl}/${id}`, dto);
  }

  public deleteArticleRange(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  // ---

  public getCategories(
    categoryType: CategoryType,
    queryModel: CategoriesFilterQueryModel,
  ): Observable<readonly CategoryBase[]> {
    return this.http.get<CategoryBase[]>(`${this.baseUrl}/categories/${categoryType}`, {
      params: {
        ...queryModel,
      },
    });
  }

  public getSuppliers(queryModel: PlatformSupplierFilterQueryModel): Observable<readonly PlatformSupplierBasic[]> {
    return this.http.get<PlatformSupplierBasic[]>(`${this.baseUrl}/platform-suppliers`, {
      params: {
        ...queryModel,
      },
    });
  }

  public getAvailableOrganizations(): Observable<readonly OrganizationBasic[]> {
    return this.http.get<OrganizationBasic[]>(`${this.baseUrl}/available-organizations`);
  }
}
